"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustmentPlanningTypes = void 0;
exports.adjustmentPlanningTypes = {
    SET_ERROR: 'ADJUSTMENT PLANNING TYPES SET ERROR',
    ON_MUTATION_CLICK: 'ADJUSTMENT PLANNING TYPES ON MUTATION',
    TOGGLE_SUCCESS_MODAL: 'ADJUSTMENT PLANNING TYPES SET SUCCESS MODAL',
};
